
import delegate from './chromeDelegate';
let type = 'serialport';
class SerialPort {
    constructor() {
        this.onReceive = delegate.createListeners(type, 'onReceive', message => message.info);
        this.onReceiveError = delegate.createListeners(type, 'onReceiveError', message => message.info);
    }
    getDevices(callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'getDevices', params: {} },
            (err, message) => {
                callback(message.ports);
            });
    }
    connect(path, options, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'connect', params: { path: path, options: options } },
            (err, message) => {
                callback(message.connection);
            });
    }
    disconnect(connectionId, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'disconnect', params: { connectionId: connectionId } },
            (err, message) => {
                callback(message.result);
            });
    }
    send(connectionId, data, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'send', params: { connectionId: connectionId, data: data } },
            (err, message) => {
                callback(message.sendInfo);
            });
    }
    flush(connectionId, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'flush', params: { connectionId: connectionId } },
            (err, message) => {
                callback(message.result);

            });
    }
    update(connectionId, options, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'update', params: { connectionId: connectionId } },
            (err, message) => {
                callback(message.result);
            });
    }
    getControlSignals(connectionId, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'getControlSignals', params: { connectionId: connectionId } },
            (err, message) => {
                callback(message.params.signals);
            });
    }
    setPaused(connectionId, paused, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'setPaused', params: { connectionId: connectionId } },
            (err, message) => {
                callback();
            });
    }

    getInfo(connectionId, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'getInfo', params: { connectionId: connectionId } },
            (err, message) => {
                callback(message.connectionInfo);
            });
    }

    getConnections(callback) {
        delegate.sendMessage(extensionId,
            { connectType: type, cmd: 'getConnections', params: { connectionId: connectionId } },
            (err, message) => {
                callback(message.connectionInfos);
            });
    }
    setControlSignals(connectionId, signals, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'setControlSignals', params: { connectionId, signals } },
            (err, message) => {
                callback(message.result);
            });
    }

    getControlSignals(connectionId, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'getControlSignals', params: { connectionId: connectionId } },
            (err, message) => {
                callback(message.signals);
            });
    }
    setBreak(connectionId, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'setBreak', params: { connectionId: connectionId } },
            (err, message) => {
                callback(message.result);
            });
    }
    clearBreak(connectionId, callback) {
        delegate.sendMessage(
            { connectType: type, cmd: 'clearBreak', params: { connectionId: connectionId } },
            (err, message) => {
                callback(message.result);
            });
    }
};
let inst = new SerialPort();
export default inst;
